import { render, staticRenderFns } from "./workRecordsWorkerSummaryPage.vue?vue&type=template&id=76701824&"
import script from "./workRecordsWorkerSummaryPage.vue?vue&type=script&lang=ts&"
export * from "./workRecordsWorkerSummaryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports